import { useState, useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import MuleSoftFilter from '../Components/MuleSoftFilter'
import MuleSoftTable from '../Components/MuleSoftTable'
import CssApiClient from '../Components/Api'
import { DateTime } from 'luxon'
import { useUser } from '../Context/UserContext'

const MuleSoftPage = () => {
  const { oktaAuth } = useOktaAuth()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [startDateTime, setStartDateTime] = useState('')
  const [endDateTime, setEndDateTime] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const userInfo = useUser()
  const [records, setRecords] = useState([])
  const [statusCode, setStatusCode] = useState(null)
  const [timezone, setTimezone] = useState('America/New_York')

  const [isLoading, setIsLoading] = useState(false)

  const logsPayload = async userAction => {
    try {
      await CssApiClient.postLog(
        {
          userId: userInfo.sub,
          email: userInfo.email,
          userAction: userAction,
          errorMessage: null,
          statusCode: 200,
          name: userInfo?.name || 'UNKNOWN',
          job_profile: userInfo?.job_profile || 'UNKNOWN'
        },
        ''
      )
    } catch (error) {
      console.warn('Cached API not available, skipping:', error)
    }
  }

  useEffect(() => {
    const fetchCachedData = async () => {
      const cached = sessionStorage.getItem('muleData')
      if (!cached) {
          logsPayload('OPEN_CAREGIVER_TAB')
          sessionStorage.setItem('muleData', true)
        }
    }
    fetchCachedData()
  }, [])

  const handleSubmit = async () => {
    setIsLoading(true)
    setRecords([])
    setStatusCode(null)

    const payload = {
      first_name: firstName,
      last_name: lastName,
      date_of_birth: birthDate,
      schedule_start_time_utc: startDateTime
        ? DateTime.fromISO(startDateTime, {
            zone: timezone
          })
            .toUTC()
            .toISO()
        : null,
      schedule_end_time_utc: endDateTime
        ? DateTime.fromISO(endDateTime, {
            zone: timezone
          })
            .toUTC()
            .toISO()
        : null,
      client_time_zone: timezone,
      excluded_caregivers: [],
      purpose: 'call-out',
      options: { 'max-results': '100' }
    }

    try {
      const response = await CssApiClient.postSchedulingRequest(
        oktaAuth,
        payload
      )
      setStatusCode(response?.statusCode || 200)
      if (response?.caregivers) {
        setRecords(response.caregivers)
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setStatusCode(404)
      } else {
        setStatusCode(error?.response?.status || 500)
      }
    } finally {
      setIsLoading(false)
    }
    logsPayload("SEARCH_CAREGIVER")
  }

  const handleReset = () => {
    setFirstName('')
    setLastName('')
    setStartDateTime('')
    setEndDateTime('')
    setBirthDate('')
    setRecords([])
  }

  return (
    <main className='flex-1 overflow-hidden'>
      <div className='h-full p-6 overflow-y-auto'>
        <div className='container mx-auto'>
          <MuleSoftFilter
            firstName={firstName}
            setFirstName={setFirstName}
            lastName={lastName}
            setLastName={setLastName}
            startDateTime={startDateTime}
            setStartDateTime={setStartDateTime}
            endDateTime={endDateTime}
            setEndDateTime={setEndDateTime}
            birthDate={birthDate}
            setBirthDate={setBirthDate}
            onSubmit={handleSubmit}
            onReset={handleReset}
            setFiltersInitialized={() => {}}
            setTimezone={setTimezone}
            timezone={timezone}
            isLoading={isLoading}
          />

          <MuleSoftTable
            records={records}
            isInitialLoading={isLoading}
            statusCode={statusCode}
          />
        </div>
      </div>
    </main>
  )
}

export default MuleSoftPage
